import { render } from "./branchCPO.vue?vue&type=template&id=6c0683dc&scoped=true"
import script from "./branchCPO.vue?vue&type=script&lang=js"
export * from "./branchCPO.vue?vue&type=script&lang=js"

import "./branchCPO.vue?vue&type=style&index=0&id=6c0683dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0683dc"]])

export default __exports__